import { createPortal } from 'react-dom';
import classnames from 'classnames';

export function Spinner({ isLoading }) {
  return (
    createPortal(
      <div className={classnames(`popup`, { [`popup_state_opened`]: isLoading })}>
        <div className={`popup__backdrop`} />
        <div className={`popup__spinner-container`}>
          <div className={`popup__spinner`} />
        </div>
      </div>,
      document.body,
    )
  )
}
